import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '@/components/Sidebar';
import QuickCaptureFab from '@/components/QuickCaptureFab';
import MobileAccountSwitcher from '@/components/MobileAccountSwitcher';
import MobileTopbar from '@/components/MobileTopbar';
import { MotionProvider } from '@/lib/motion/MotionContext';
import { MotionPanel } from '@/lib/motion/MotionPanel';
import { useToast } from '@/components/Toast';

const HIDE_FAB_PATHS = ['/onboarding', '/login', '/auth/callback'];

export default function AppShell() {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const hideFab = HIDE_FAB_PATHS.some(p => location.pathname.startsWith(p));

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('drive_connected') === '1') {
      toast.success('Google Drive pripojený.');
      sessionStorage.removeItem('drive_oauth_return');
      params.delete('drive_connected');
      const newSearch = params.toString();
      navigate(location.pathname + (newSearch ? `?${newSearch}` : ''), { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <MotionProvider>
      <div className="cd-app">
        <Sidebar />
        <main className="cd-main">
          <div key={location.pathname} className="cd-page" style={{ flex: 1, overflowY: 'auto' }}>
            <Outlet />
          </div>
        </main>
        {!hideFab && <QuickCaptureFab />}
        <MobileTopbar />
        <MobileAccountSwitcher />
        {/* Multi-color stripe — fixed na bottom (pod MobileAccountSwitcher) */}
        <img src="/todue-stripes.svg" alt="" aria-hidden="true"
          className="cd-stripes-bottom"
          style={{
            position: 'fixed', bottom: 0, left: 0, right: 0,
            display: 'block', width: '100%', height: 5,
            zIndex: 879, pointerEvents: 'none',
          }} />
        <MotionPanel />
      </div>
    </MotionProvider>
  );
}
